import { LinkedinFilled } from '@ant-design/icons'
import React from 'react'
import { NavLink } from 'react-router-dom'

const Footer = () => {
  return (
    <div className="applyin-footer">
      <div>
        {/* <h1>Creole studios</h1> */}
        <div>
          <a href="/" target="_blank">
            Copyright © 2023 Creole Studios, Inc All rights reserved.
          </a>
        </div>
      </div>
      <div className="applyin-linkedin">
        <a href="https://www.creolestudios.com/" target="_blank">
          Made by CreoleStudios &nbsp;&nbsp;
        </a>
      </div>
    </div>
  )
}

export default Footer
